<div class="border-none" [formGroup]="form" [hidden]="!this.visible">
  @switch(field.controlType) {
    @case ('input') {
      <lib-input-field [field]=" field" [form]="form" class="border-none">
          @if(field.icon) {
            <lib-app-icon [icon]="field.icon" suffix size="48x48" className="p-[12px]" />
          }
      </lib-input-field>
    }
    @case ('inputWithSuffix') {
      <lib-input-with-suffix-field [field]="field" [form]="form" />
    }
    @case ('datepicker') {
      <lib-date-picker [field]="field" [form]="form" />
    }
    @case ('dateRangePicker') {
      <lib-date-range-picker [field]="field" [form]="form" />
    }
    @case ('lookup') {
      <lib-lookup-field [field]="this.field" [form]="form" />
    }
    @case ('checkbox') {
      <lib-checkbox [field]="field" [form]="form" />
    }
    @case ('fab') {
      <lib-floating-action-button [field]="field" [form]="form" />
    }
    @case ('chipSet') {
      <lib-chip-set [field]="field" [form]="form" />
    }
    @case ('autocomplete') {
      <lib-autocomplete [field]="field" [form]="form" />
    }
    @case ('row') {
      <div [class]="field.className" [id]="field.key">
        @if(field.label) {
          <span [class]="field.labelClassName">{{field.label}}</span>
        }
      
        @for(internalField of field.internalFields; track internalField.key) {
          <lib-dynamic-form-field [field]="internalField" [form]="form" [class]="internalField.className" />
        }
      
      </div>
    }
    @case ('label') {
      <div [class]="field.className">{{field.value}}</div>
    }
    @case ('section') {
      <div [class]="field.className" [id]="field.key">
        @if(field.label) {
          <h4 [class]="field.labelClassName">{{field.label}}</h4>
        }
      
        @for(internalField of field.internalFields; track internalField.key) {
          <lib-dynamic-form-field [field]="internalField" [form]="form" />
        }
      
        @if(field.type !== 'borderless') {
          <mat-divider></mat-divider>
        }
      </div>
    }
    @case('conditionalSection') {
      <lib-conditional-section [field]="field" [form]="form">
        @for(f of this.field.internalFields; track f.key) {
          <lib-dynamic-form-field [field]="f" [form]="form" [visible]="!this.isHidden(f)"/>
        }
      </lib-conditional-section>
    }
    @default {
      <div>Not implemented field</div>
    }
  }
</div>